import {Css} from 'cytoscape';
import {CytoscapeEdgeData, GraphEdge, GraphLayout, GraphNode} from '../interface';
import {
    getDefaultEdgeStyles,
    getHiddenNodeStyles,
    getSelectedEdgeStyles,
    getSelectedNodeStyles,
    getUnhiddenNodeStyles,
    getUnhoveredNodeStyles,
    getUnselectedNodeStyles
} from './get-dynamic-styles';
import {getEdgeCytoscapeId} from '../utils';

export function createNodeElement(
    node: GraphNode,
    nodePositions: GraphLayout,
    getIsNodePartiallyHidden: (id: number) => boolean,
    isNodeSelected: boolean
) {
    return {
        data: {id: `${node.id}`, nodeType: node.nodeType, label: node.label},
        position: nodePositions[node.id],
        style: {
            ...getUnhoveredNodeStyles(),
            ...(isNodeSelected ? getSelectedNodeStyles() : getUnselectedNodeStyles()),
            ...(getIsNodePartiallyHidden(node.id) ? getHiddenNodeStyles() : getUnhiddenNodeStyles())
        }
    };
}

export function createEdgeElement(
    edge: GraphEdge,
    getIsEdgePartiallyHidden: (edgeId: number) => boolean,
    isEdgeSelected: boolean
): {data: CytoscapeEdgeData; style: Css.Edge} {
    return {
        data: {
            id: getEdgeCytoscapeId(edge.id),
            source: `${edge.startViewNodeId}`,
            target: `${edge.endViewNodeId}`,
            presentation: edge.presentation
        },
        style: isEdgeSelected
            ? getSelectedEdgeStyles()
            : getDefaultEdgeStyles(getIsEdgePartiallyHidden(edge.id))
    };
}
